// extracted by mini-css-extract-plugin
module.exports = {"illustration":"CronJobDetailsModal_illustration__N9HrX","executionLoader":"CronJobDetailsModal_executionLoader__2JjwW"};